import {
    getGridDateOperators,
    getGridNumericOperators,
    getGridSingleSelectOperators,
    getGridStringOperators,
    GridFilterOperator,
} from "@mui/x-data-grid";
import { SenecDataGridDateInput } from "src/components/tables/table-utils/SenecDataGridDateInput";
import { SenecGridFilterInput } from "src/components/tables/senec-data-grid/SenecDataGrid";

export const locales = ["en", "it", "de"] as const;

export type LocaleKey = (typeof locales)[number];

export interface FilterItem {
    id: number;
    field: string;
    operator: string;
    value: string;
}

/**
 * @returns allowed filter operators to be used for string values
 */
export const getStringFilterOperators = (allowedStringFilterOperators: string[]): GridFilterOperator[] => {
    return getGridStringOperators().filter((operator) => allowedStringFilterOperators.includes(operator.value));
};

/**
 * @returns allowed filter operators to be used for numeric values
 */
export const getNumericFilterOperators = (allowedNumericFilterOperators: string[]): GridFilterOperator[] => {
    return getGridNumericOperators().filter((operator) => {
        const filterOperator = {
            ...operator,
            InputComponentProps: {
                InputComponent: SenecGridFilterInput,
                type: "number",
                InputProps: { inputProps: { min: 0 } },
            },
        };
        return allowedNumericFilterOperators.includes(filterOperator.value);
    });
};

/**
 * @returns allowed filter operators to be used for date values
 */
export const getDateFilterOperators = (allowedDateFilterOperators: string[], locale: LocaleKey = "de"): GridFilterOperator[] => {
    const operators = getGridDateOperators().map((operator) => {
        return {
            ...operator,
            label: operator.label,
            value: operator.value,
            InputComponent: SenecDataGridDateInput,
            InputComponentProps: { locale: locale },
        };
    });
    return operators.filter((operator) => allowedDateFilterOperators.includes(operator.value));
};

/**
 * @returns allowed filter operators to be used for select operators
 */
export const getSingleSelectOperators = (allowedOperators: string[], locale: LocaleKey = "de"): GridFilterOperator[] => {
    const operators = getGridSingleSelectOperators().map((operator) => {
        return {
            ...operator,
            label: operator.label,
            value: operator.value,
            InputComponent: SenecDataGridDateInput,
            InputComponentProps: { locale: locale },
        };
    });
    return operators.filter((operator) => allowedOperators.includes(operator.value));
};
